import { GraphQLClient } from "../../../../../shared/gql-client";
import * as gqlBuilder from "gql-query-builder";
import { gql } from "@apollo/client";
import {
  ExportPackingListModel,
  PackingListModel,
} from "../../domain/models/packingListModel";

export default class PackingListService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  queryPackingList(
    date: string,
    type: string,
  ): Promise<PackingListModel | null> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.query({
        operation: "PackingList",
        variables: {
          date: { type: "Date!", value: date },
          type: { type: "PackingListType", value: type },
        },
        fields: [
          "id",
          "label",
          {
            items: [
              "id",
              "label",
              {
                source: [
                  { "... on Warehouse": ["label"] },
                  { "... on Route": ["label"] },
                ],
              },
              {
                items: [
                  "id",
                  "label",
                  {
                    source: [
                      { "... on Path": ["label"] },
                      { "... on PackingSlip": ["id", "label"] },
                    ],
                  },
                  {
                    requests: [
                      "id",
                      "state",
                      "finalized",
                      {
                        relation: ["name", "id"],
                      },
                      {
                        source: [
                          {
                            "... on Tireset": [
                              { car: ["licence", "label"] },
                              { position: ["label"] },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      });

      this.client
        ?.query("PackingList", gql(query), variables)
        .then((response) => {
          const data = response as PackingListModel[];
          if (data.length === 0) {
            resolve(null);
          }
          resolve(data[0]);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  exportPackingList(
    date: string,
    type: string,
  ): Promise<ExportPackingListModel | null> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.query({
        operation: "exportPackingList",
        variables: {
          date: { type: "Date!", value: date },
          type: { type: "PackingListType!", value: type },
        },
        fields: ["url", "filename", "mimeType"],
      });

      this.client
        ?.query("exportPackingList", gql(query), variables)
        .then((response) => {
          const data = response as ExportPackingListModel;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
